"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFormatter = exports.AuditDetailsDialog = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const utils_1 = require("@juvare/common-web-ui/utils");
const formatDateTime_1 = require("@juvare/common-web-ui/utils/formatDateTime");
const useAuditGet_1 = require("../../../../ui/hooks/useAuditGet");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const diff_1 = require("../utils/diff");
const dot_1 = require("../utils/dot");
const AuditDetailsDialog = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const { data, isLoading, isValidating, error } = (0, useAuditGet_1.useAuditGet)(props.id);
    const ariaLabelledById = `audit-dialog-title-${props.id}`;
    const ariaDescribedById = `audit-dialog-description-${props.id}`;
    let Details;
    if (data) {
        if (data.eventType === 'create') {
            Details = (react_1.default.createElement(FieldDiffDataTable, { data: (_a = data.params) === null || _a === void 0 ? void 0 : _a.data, entityAuditMapping: (_b = data.params) === null || _b === void 0 ? void 0 : _b.entityAuditMapping, t: t, formatters: props.formatters }));
        }
        else if (data.eventType === 'update') {
            Details = (react_1.default.createElement(FieldDiffDataTable, { data: (_c = data.params) === null || _c === void 0 ? void 0 : _c.data, prevData: (_d = data.params) === null || _d === void 0 ? void 0 : _d.prevData, entityAuditMapping: (_e = data.params) === null || _e === void 0 ? void 0 : _e.entityAuditMapping, t: t, formatters: props.formatters }));
        }
        else if (data.eventType === 'delete') {
            Details = (react_1.default.createElement(FieldDiffDataTable, { prevData: (_f = data.params) === null || _f === void 0 ? void 0 : _f.prevData, entityAuditMapping: (_g = data.params) === null || _g === void 0 ? void 0 : _g.entityAuditMapping, t: t, formatters: props.formatters }));
        }
        else if (data.eventType === 'get') {
            Details = react_1.default.createElement(FieldDataTable, { data: { id: data.entityId }, t: t });
        }
        else if (data.eventType === 'list' || data.eventType === 'mass-create') {
            Details = react_1.default.createElement(FieldDataTable, { data: data.params, t: t });
        }
    }
    return (react_1.default.createElement(material_1.Dialog, { fullWidth: true, maxWidth: 'md', open: true, "aria-labelledby": ariaLabelledById, "aria-describedby": ariaDescribedById },
        react_1.default.createElement(material_1.DialogTitle, { id: ariaLabelledById }, props.dialogTitle ? props.dialogTitle : t('audit.dialogHeader')),
        react_1.default.createElement(material_1.DialogContent, { id: ariaDescribedById },
            data && error == null && (react_1.default.createElement(material_1.Box, { sx: { backgroundColor: JuvareTheme_1.themeColors.surface.secondary, m: 0, p: 2, fontSize: 12 } },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
                    react_1.default.createElement(GridItem, { label: t('audit.dateTime'), value: (0, formatDateTime_1.formatDateTime)(new Date(data.timestamp)) }),
                    react_1.default.createElement(GridItem, { label: t('audit.userName'), value: data.userName }),
                    data.originUserName && react_1.default.createElement(GridItem, { label: t('audit.originUserName'), value: data.originUserName }),
                    data.entityName && react_1.default.createElement(GridItem, { label: t('audit.entity'), value: data.entityName }),
                    react_1.default.createElement(GridItem, { label: t('audit.eventType'), value: data.eventType })))),
            !isLoading && !isValidating && error != null && react_1.default.createElement(material_1.Alert, { severity: 'error' }, (0, utils_1.getErrorMessage)(error)),
            Details && react_1.default.createElement(material_1.Box, { pt: 2 }, Details)),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => props.onClose() }, t('common.ok')))));
};
exports.AuditDetailsDialog = AuditDetailsDialog;
const FieldDiffDataTable = ({ data, prevData, t, entityAuditMapping = {}, formatters = {} }) => {
    const defaultFormatters = {
        '.*timestamp.*|.*createdAt|.*updatedAt': (key, oldValue, newValue) => {
            const result = {};
            if (oldValue && !isNaN(oldValue)) {
                result.oldValue = (0, formatDateTime_1.formatDateTime)(new Date(oldValue));
            }
            if (newValue && !isNaN(newValue)) {
                result.newValue = (0, formatDateTime_1.formatDateTime)(new Date(newValue));
            }
            return result;
        },
    };
    const columns = [
        {
            cellField: 'id',
            headerLabel: t('audit.field'),
            showToolbarWhenTextOverflows: true,
        },
        {
            cellField: 'oldValue',
            headerLabel: t('audit.oldValue'),
            showToolbarWhenTextOverflows: true,
        },
        {
            cellField: 'newValue',
            headerLabel: t('audit.newValue'),
            showToolbarWhenTextOverflows: true,
        },
    ];
    const objectDiff = (0, diff_1.diff)((0, dot_1.dot)(prevData !== null && prevData !== void 0 ? prevData : {}), (0, dot_1.dot)(data !== null && data !== void 0 ? data : {}));
    const rows = Object.entries(objectDiff).map(([key, { oldValue, newValue }]) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const formatter = (0, exports.findFormatter)(key, Object.assign(Object.assign({}, formatters), defaultFormatters));
        const result = (formatter && formatter(key, (_a = entityAuditMapping[oldValue]) !== null && _a !== void 0 ? _a : oldValue, (_b = entityAuditMapping[newValue]) !== null && _b !== void 0 ? _b : newValue)) || undefined;
        return {
            id: ((_c = result === null || result === void 0 ? void 0 : result.key) !== null && _c !== void 0 ? _c : formatAuditFieldName(key, entityAuditMapping)),
            oldValue: ((_e = (_d = result === null || result === void 0 ? void 0 : result.oldValue) !== null && _d !== void 0 ? _d : entityAuditMapping[oldValue]) !== null && _e !== void 0 ? _e : oldValue),
            newValue: ((_g = (_f = result === null || result === void 0 ? void 0 : result.newValue) !== null && _f !== void 0 ? _f : entityAuditMapping[newValue]) !== null && _g !== void 0 ? _g : newValue),
        };
    });
    return react_1.default.createElement(DataTable_1.DataTable, { columns: columns, loading: false, rows: rows, tableSx: { tableLayout: 'fixed' } });
};
const findFormatter = (key, formatters) => {
    const formatterKey = Object.keys(formatters).find((formatterKey) => new RegExp(formatterKey, 'i').test(key));
    return !!formatterKey ? formatters[formatterKey] : undefined;
};
exports.findFormatter = findFormatter;
function formatAuditFieldName(fieldName, entityAuditMapping) {
    var _a;
    if (entityAuditMapping) {
        ((_a = fieldName.match(/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi)) !== null && _a !== void 0 ? _a : [])
            .filter((uuid) => entityAuditMapping[uuid])
            .forEach((uuid) => {
            fieldName = fieldName.replace(uuid, entityAuditMapping[uuid]);
        });
    }
    return fieldName;
}
const FieldDataTable = ({ data, t }) => {
    const columns = [
        {
            cellField: 'id',
            headerLabel: t('audit.field'),
        },
        {
            cellField: 'value',
            headerLabel: t('audit.value'),
        },
    ];
    const rows = Object.entries((0, dot_1.dot)(data !== null && data !== void 0 ? data : {})).map(([id, value]) => ({ id, value }));
    return react_1.default.createElement(DataTable_1.DataTable, { columns: columns, loading: false, rows: rows, tableSx: { tableLayout: 'fixed' } });
};
const GridItem = ({ label, value }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Grid, { item: true, xs: 4 },
            react_1.default.createElement(material_1.Typography, { variant: 'body2', color: 'textSecondary' }, label)),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 8 },
            react_1.default.createElement(material_1.Typography, { variant: 'body2' }, value))));
};
